
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.454 4.665a4.175 4.175 0 00-1.554-.173h-2.38a1.943 1.943 0 01-1.482-.71L9.262 2.71A1.894 1.894 0 007.754 2H6.09C3.103 2 2 3.754 2 6.735V13.223c0 .354.028.708.085 1.058.09.618.303 1.212.626 1.746.148.258.327.497.534.71a4.821 4.821 0 003.5 1.257h6.5a4.8 4.8 0 003.493-1.257c.21-.213.39-.451.54-.71a4.792 4.792 0 00.64-1.746c.052-.35.078-.704.079-1.058V9.021c.01-.32-.003-.642-.039-.96-.168-1.839-.907-2.983-2.504-3.396zm-9.478 6.847h8.116a.626.626 0 01.498.256c.101.118.152.27.142.426a.66.66 0 01-.69.639H5.976a.66.66 0 110-1.32z","fill":"#94A3B8"}})])
          )
        }
      }
    